import Vue from 'vue'
import axios from 'axios'
import LightBox from 'vue-easy-lightbox'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/moment'
import i18n from './plugins/i18n'
import './registerServiceWorker'
import moment from 'moment'
import 'moment/locale/ru'

Vue.prototype.moment = moment

Vue.config.productionTip = false
Vue.use(LightBox)

axios.defaults.baseURL = 'https://kluchi.onoi.kg'

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
